export default __webpack_public_path__ + "static/media/Calling-1-v2.0ba45ec6.svg";